var eqNull = require('../base/eqNull')
var isNumber = require('../base/isNumber')

var toNumberString = require('../number/toNumberString')

function toValString (obj) {
  if (isNumber(obj)) {
    return toNumberString(obj)
  }
  return '' + (eqNull(obj) ? '' : obj)
}

module.exports = toValString



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/string/toString.js
// module id = 32
// module chunks = 106